module.exports = __webpack_public_path__ + "static/media/8.ea431b5d.png";